const state = {
    photobook: null
}

export const getters = {
    photobook: state => state.photobook,
    photos: state => {
        if (!state.photobook) return []
        const photos = []
        photos.push({id: 0, url: state.photobook.front_cover_url})
        photos.push(...state.photobook.photos)
        if (state.photobook.photos.length % 2 !== 0) photos.push({id: 88888, url: require('@/assets/photobook/pages/blank.jpg')})
        photos.push({id: 99999, url: state.photobook.back_cover_url})
        return photos
    },
    isMobile: () => /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 768
}


export const mutations = {
    set_photobook(state, photobook) {
        state.photobook = photobook
    }
}


export const actions = (photobookService) => ({
    async fetchPhotobook({commit}, params) {
        try {
            const data = await photobookService.getPhotobook(params)
            commit('set_photobook', data)
            return data.photobook
        } catch (e) {
            commit('set_photobook', {error: e})
        }
    }
})

export default photobookService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(photobookService)
})
